<template>
  <WizardLayout>
    <template #title>Tell us about your project</template>

    <div class="d-flex flex-column">
      <v-form ref="form" @submit.prevent="onSubmit">
        <div 
          class="ma-2 py-4 px-3 white rounded d-flex flex-column"
          style="gap: 12px;"
        >
          <div class="px-1" style="line-height: 1.2;">
            Please provide us with as much information as you can about your project.
            This aids the experts in getting ready to speak with you.
          </div>

          <v-textarea
            auto-grow outlined
            v-model="notes"
            placeholder="How can a pro help you?"
            hide-details="auto"
            :rules="[required]"
          />

          <v-img src="@/assets/wizard/guywdrill.png" />

          <div class="d-flex mt-2" style="gap: 12px;">
            <v-spacer/>
            <v-btn @click="$router.replace({ name: 'wizard/property' })">Back</v-btn>
            <v-btn type="submit" color="primary">Next</v-btn>
            <v-spacer/>
          </div>
        </div>
      </v-form>

      <WizardOverlay 
        v-model="error_dialog"
        @close="$router.replace({ name: 'link' })"
      />
    </div>
  </WizardLayout>
</template>

<script>
import { WizardLayout } from '@/layouts'
import { WizardOverlay } from '@/components/pages'

import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'QRNotesView',

  components: { WizardLayout, WizardOverlay },

  data: () => ({
    loading: false,
    error_dialog: false,
    
    notes: '',

    // validations
    required,
  }),

  computed: {
    ...mapGetters('qr', ['request']),
  },

  methods: {
    ...mapActions('qr', ['missingStageRequirements', 'setNotes']),

    onSubmit() {
      if (this.$refs.form.validate()) {
        const { notes } = this

        this.setNotes({ notes })
        this.$router.replace({ name: 'wizard/contact' })
      }
    }
  },

  async created() {
    const result = await this.missingStageRequirements(3)
    if (result) {
      this.error_dialog = true
    }
  },
}
</script>